import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowRight, DollarSign, Globe, Truck } from 'lucide-react';
export function FundraisersPage() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-515">
      <Header data-id="element-516" />

      <main className="flex-grow" data-id="element-517">
        {/* Hero */}
        <section className="bg-gradient-to-br from-green-600 to-teal-600 text-white py-20 md:py-32" data-id="element-518">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-519">
            <h1 className="text-4xl md:text-6xl font-bold mb-6" data-id="element-520">
              Hassle-Free Fundraising
            </h1>
            <p className="text-xl text-green-100 max-w-3xl mx-auto mb-10" data-id="element-521">
              Raise money for your cause without the headache. We build your
              online store, handle the orders, and send you a check for the
              profits.
            </p>
            <a href="/contact" className="inline-flex items-center px-8 py-4 bg-white text-green-700 font-bold rounded-full shadow-lg hover:bg-gray-50 transition-all transform hover:-translate-y-1" data-id="element-522">
              Start a Fundraiser
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-523" />
            </a>
          </div>
        </section>

        {/* How It Works */}
        <section className="py-20" data-id="element-524">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-525">
            <div className="text-center mb-16" data-id="element-526">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-527">
                How It Works
              </h2>
              <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-528">
                We've simplified the process so you can focus on promoting your
                cause, not managing spreadsheets.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-529">
              <div className="text-center" data-id="element-530">
                <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-531">
                  <Globe className="h-10 w-10 text-teal-600" data-id="element-532" />
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-533">
                  1. We Build Your Store
                </h3>
                <p className="text-gray-600" data-id="element-534">
                  Select your products and designs. We create a custom web page
                  for your supporters to shop.
                </p>
              </div>
              <div className="text-center" data-id="element-535">
                <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-536">
                  <Truck className="h-10 w-10 text-teal-600" data-id="element-537" />
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-538">2. We Produce & Ship</h3>
                <p className="text-gray-600" data-id="element-539">
                  We handle all printing, sorting, and shipping. Orders can be
                  shipped directly to homes or bulk shipped to you.
                </p>
              </div>
              <div className="text-center" data-id="element-540">
                <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-541">
                  <DollarSign className="h-10 w-10 text-teal-600" data-id="element-542" />
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-543">3. You Get Paid</h3>
                <p className="text-gray-600" data-id="element-544">
                  Once the fundraiser closes, we send you a check for the
                  proceeds. No upfront costs, no risk.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bg-gray-900 text-white py-20" data-id="element-545">
          <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-546">
            <h2 className="text-3xl font-bold mb-6" data-id="element-547">Ready to raise funds?</h2>
            <p className="text-gray-400 text-lg mb-8" data-id="element-548">
              Perfect for schools, sports teams, non-profits, and community
              causes. Let's start planning your campaign today.
            </p>
            <a href="/contact" className="inline-block px-8 py-3 bg-teal-500 hover:bg-teal-600 text-white font-bold rounded-full transition-all" data-id="element-549">
              Launch Your Campaign
            </a>
          </div>
        </section>
      </main>

      <Footer data-id="element-550" />
    </div>;
}